module.exports = __webpack_public_path__ + "static/media/logoListaDocente.cf41b3b1.svg";